<template>
  <div>
    <div v-if="message" class="text-center text-muted">{{ message }}</div>

    <div class="main scroll-styled">

      <div v-if="isCustomer && isApproval" class="p-2">
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th>Material</th>
              <th class="text-right">Ações</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="entries.length > 0">
              <tr v-for="entry in entries" :key="entry.name">
                <td class="align-middle">
                  <img :src="getImg(entry)" style="width: 24px; height: 24px; margin-right: 8px;"/>
                  {{ entry.name }}
                </td>
                <td class="text-right align-middle">
                  <button
                    v-if="canView(entry)"
                    class="btn btn-sm btn-outline-primary mr-1"
                    @click="entryClick(entry)"
                  >
                    <i class="la la-eye"></i> Ver
                  </button>
                  <a
                    :href="file(entry) + '&download=1'"
                    :download="entry.name"
                    class="btn btn-sm btn-outline-success"
                  >
                    <i class="la la-download"></i> Download
                  </a>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="2" class="text-center">Nenhum arquivo em aprovação. Contate o seu atendimento</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div v-else class="d-flex flex-wrap">
        <div v-for="entry in entries" :key="entry.name" class="entry img-thumbnail" @click="entryClick(entry)">
          <img :src="getImg(entry)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {H} from 'hennig-common'
import {getEntryType} from '../../common'

export default {
  name: 'FileViewWrap',
  props: {
    param: {},
    isCustomer: {
      type: Boolean,
      default: false
    },
    isApproval: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tree: [],
      message: '',
      current_entry: {},
    }
  },
  computed: {
    entries () {
      return this.tree.filter(row => !row.folder)
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    getType (entry) {
      return getEntryType(entry)
    },
    canView (entry) {
      const type = getEntryType(entry)
      return ['image', 'video', 'text'].includes(type)
    },
    getImg (entry) {
      const type = getEntryType(entry)

      if (type === 'image') {
        return this.file(entry)
      }

      if (entry.folder) {
        return '/img/folder.svg'
      }

      if (type === 'txt') {
        return '/img/txt.svg'
      }

      if (type === 'video') {
        return '/img/video.svg'
      }

      if (type === 'audio') {
        return '/img/audio.svg'
      }

      if (type === 'doc') {
        return '/img/doc.svg'
      }

      if (type === 'xls') {
        return '/img/xls.svg'
      }

      if (type === 'pdf') {
        return '/img/pdf.svg'
      }
      if (type === 'zip') {
        return '/img/zip.svg'
      }

      return '/img/default-file.svg'
    },
    entryClick (entry) {
      const index = this.entries.indexOf(entry)
      this.dialogs().ImageView.show({param: this.param, entries: this.entries, index})
    },
    load () {
      clearTimeout(this.handler)
      this.handler = setTimeout(() => {
        H.rpc('Media', 'list', [this.param], (r, e) => {
          this.tree = r || {}
          if (e) {
            this.message = e.message
            setTimeout(() => {
              this.message = ''
            }, 3000)
            return true
          }
        })
      }, 500)
    },
    file (entry) {
      return '/media/file?q=' + btoa(JSON.stringify({
        param: this.param,
        path: entry.path
      }))
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/sass/variables";

.main {
  height: 400px;
  overflow-y: auto;
}

.entry {
  margin: .5em;
  width: 100px;
  height: 100px;
  overflow: hidden;
}

img {
  width: 100%;
  height: auto;
}

::v-deep {
  .modal-dialog {
    height: 80%;
  }

  .modal-content {
    height: 100%;
  }
}
</style>
